export default __webpack_public_path__ + "static/media/Parkir.be149ca2.png";